import { EmbeddedViewRef, ViewRef } from '@angular/core';
import { $, $Element } from './element';

export function getComponentRefElement(hostView: ViewRef): $Element {
    return $((hostView as EmbeddedViewRef<any>).rootNodes[0]);
}
